module.exports = "/_next/static/images/nyancat-f48cb1a84600ad81f85dc0895dd5c6b2.png";